import InputField from "../../applicationUi/components/intake/InputField";
import SelectField from "../../applicationUi/components/intake/SelectField";

const ClientInformationSection = ({ formData, handleChange }) => (
  <div className="space-y-8">
    {/* Client Basic Information */}
    <div className="space-y-4">
      <div className="border-b pb-2">
        <h3 className="text-lg font-semibold">Client Information</h3>
        <p className="text-sm text-gray-500">
          Enter the client's basic information and contact details.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="First Name"
          name="client.firstName"
          value={formData.client.firstName}
          onChange={handleChange}
          required
        />
        <InputField
          label="Last Name"
          name="client.lastName"
          value={formData.client.lastName}
          onChange={handleChange}
          required
        />
        <InputField
          label="Email"
          name="client.email"
          value={formData.client.email}
          onChange={handleChange}
          type="email"
          description="Primary contact email for the client"
        />
        <SelectField
          label="Gender"
          name="client.gender"
          value={formData.client.gender}
          onChange={handleChange}
          options={[
            { value: "", label: "Select Gender" },
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "transgender", label: "Transgender" },
            { value: "genderqueer", label: "Genderqueer" },
            { value: "non-binary", label: "Non-binary" },
            { value: "agender", label: "Agender" },
            { value: "bigender", label: "Bigender" },
            { value: "other", label: "Other" },
          ]}
        />
        <SelectField
          label="Pronouns"
          name="client.pronouns"
          value={formData.client.pronouns}
          onChange={handleChange}
          options={[
            { value: "", label: "Select Pronouns" },
            { value: "he/him", label: "He/Him" },
            { value: "she/her", label: "She/Her" },
            { value: "they/them", label: "They/Them" },
            { value: "xe/xem", label: "Xe/Xem" },
            { value: "ze/zir", label: "Ze/Zir" },
            { value: "other", label: "Other" },
          ]}
        />
        <InputField
          label="Date of Birth"
          name="client.dob"
          value={formData.client.dob}
          type="date"
          onChange={handleChange}
          required
        />
      </div>
    </div>

    {/* Medical Information */}
    <div className="space-y-4">
      <div className="border-b pb-2">
        <h3 className="text-lg font-semibold">Medical Information</h3>
        <p className="text-sm text-gray-500">
          Provide details about the client's medical contacts and referrals.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="Doctor's Name"
          name="client.doctorName"
          value={formData.client.doctorName}
          onChange={handleChange}
          description="Primary care physician"
        />
        <InputField
          label="Doctor's Phone"
          name="client.doctorPhone"
          value={formData.client.doctorPhone}
          onChange={handleChange}
          description="Contact number for the doctor's office"
        />
        <InputField
          label="Referral Source"
          name="client.referralSource"
          value={formData.client.referralSource}
          onChange={handleChange}
          description="How did you hear about us?"
        />
        <InputField
          label="Referral Reason"
          name="client.referralReason"
          value={formData.client.referralReason}
          onChange={handleChange}
          description="Primary reason for seeking services"
        />
      </div>
    </div>

    {/* Address Information */}
    <div className="space-y-4">
      <div className="border-b pb-2">
        <h3 className="text-lg font-semibold">Address Information</h3>
        <p className="text-sm text-gray-500">
          Enter the client's current residential address.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="Apartment/Unit"
          name="client.address.aptUnit"
          value={formData.client.address.aptUnit}
          onChange={handleChange}
          description="If applicable"
        />
        <div className="grid grid-cols-2 gap-4">
          <InputField
            label="Street Number"
            name="client.address.streetNumber"
            value={formData.client.address.streetNumber}
            onChange={handleChange}
            required
          />
          <InputField
            label="Street Name"
            name="client.address.streetName"
            value={formData.client.address.streetName}
            onChange={handleChange}
            required
          />
        </div>
        <InputField
          label="City"
          name="client.address.city"
          value={formData.client.address.city}
          onChange={handleChange}
          required
        />
        <InputField
          label="Province"
          name="client.address.province"
          value={formData.client.address.province}
          onChange={handleChange}
          required
        />
        <InputField
          label="Postal Code"
          name="client.address.postalCode"
          value={formData.client.address.postalCode}
          onChange={handleChange}
          required
        />
        <InputField
          label="Country"
          name="client.address.country"
          value={formData.client.address.country}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  </div>
);

export default ClientInformationSection;
